module.exports = __webpack_public_path__ + "img/470.463d86cb.jpg";